import React from "react";
import { getContentPageProps, getUniqueIdForContentTypeAlias } from "../../logic/contentLogic";

const FullscreenVideo = React.lazy(() => import("../../components/Magazine/modules/fullscreenVideoContainer/FullscreenVideoContainer.js"));

export const renderFullscreenVideo = (content, props = {}) => {
  return <FullscreenVideo key={getUniqueIdForContentTypeAlias(content.contentTypeAlias)} content={content} {...getContentPageProps(content)} />;
};
